import { useMatchMedia } from "replo-utils/react/use-match-media";

const MOBILE_BREAKPOINT = 768;
const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

export function useIsMobile() {
  return useMatchMedia(MOBILE_MEDIA_QUERY);
}
